/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { ILimitsModal } from './modal_limits_user';

export function updateState(
    target: Object, propertyKey: string, descriptor: any): TypedPropertyDescriptor<any> {

    let originalMethod = descriptor.value;

    descriptor.value = function(...args: any[]) {
        this.loading = true;
        let result: Promise<ILimitsModal> = originalMethod.apply(this, args);
        if (result instanceof Promise) {
            return result.then(() => {
                return this.update()
                    .then(() => this.loading = false)
                    .catch(() => this.loading = false);
            });
        }
    };

    return descriptor;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/decorators.ts